import { APPOINTMENT_STATUS } from "../../../utils/appointmentLabels";
import { Badge } from "../../ui";

export default function StatusBadge({ status }) {
  const meta = APPOINTMENT_STATUS[status] || {
    label: status,
    tone: "gray",
  };
  return <Badge tone={meta.tone}>{meta.label}</Badge>;
}
